import { createSlice } from "@reduxjs/toolkit";

const serviceBannerSlice = createSlice({
  name: "serviceBanner",
  initialState: null,
  reducers: {
    receiveServiceBanner: (_state, { payload }) => payload,
  },
});

export const { receiveServiceBanner } = serviceBannerSlice.actions;

export default serviceBannerSlice.reducer;
